<script setup lang="ts">
interface Props {
  modelValue: boolean
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void
  (e: 'renew'): void
  (e: 'logout'): void
}

defineProps<Props>()
defineEmits<Emits>()
</script>

<template>
  <v-dialog :model-value="modelValue" max-width="400" persistent>
    <v-card>
      <v-card-title>Session Expiring</v-card-title>
      <v-card-text>You are about to be logged out due to inactivity.</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="grey" @click="$emit('logout')">Log Out</v-btn>
        <v-btn color="primary" @click="$emit('renew')">Stay Logged In</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
